import React from "react";

import { st, Modal, FormControl, AppSettings, Button } from "lib/index";

class ManageLocalesPrompt extends React.PureComponent {
  state = {
    selectedLocales: [],
  };

  componentDidMount() {
    const { locales } = this.props;
    this.setState({ selectedLocales: locales });
  }

  render() {
    const { modalRef, resolve, locales, ...props } = this.props;
    const { selectedLocales } = this.state;

    return (
      <Modal closeIcon closeOnDimmerClick={false} size="small" ref={modalRef} {...props}>
        <Modal.Header>{I18n.t("papp.products.ManageLocalesPrompt.title")}</Modal.Header>,
        <Modal.Content>
          <div className="ui form">
            <FormControl.LocaleSelectFormGroup
              value={selectedLocales}
              onChange={(selectedLocales) => this.setState({ selectedLocales })}
              locales="customer_locales"
              label={I18n.t("papp.products.ManageLocalesPrompt.select_locale")}
              multiple
              className="u-massiveWidth"
              search
            />
          </div>
        </Modal.Content>
        ,
        <Modal.Actions>
          <Button as="a" onClick={() => resolve()} content={I18n.t("papp.common.cancel")} />
          <Button
            as="a"
            primary
            floated="right"
            onClick={() => resolve(selectedLocales)}
            disabled={selectedLocales.length === 0}
            content={I18n.t("papp.common.save")}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default function openManageLocalesPrompt(props) {
  return st.createModal(ManageLocalesPrompt, props);
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/ManageLocalesPrompt.jsx